import { GrowthBook } from '@growthbook/growthbook';

import { getPersistentUuid } from '../helpers/uuid';
import { pushGtmEvent } from '..';

import { CONTROL_FEATURE_VALUE } from './constants';
import { getFeatureValueFromStorage, saveFeatureValueToStorage } from './storage';

const uuid = getPersistentUuid();
type GB = { growthbook: GrowthBook };


/**
 * Growthbook.
 *
 * Usage:
 * import { _apipe } from 'utils';
 *
 * _apipe(
 *   _initGrowthbook,
 *   _getFeatureValue('test-feature-1'),
 *   ({ featureValue }) => {
 *     //  your code based on {featureValue}
 *   }
 * )();
 */

export const growthbook = new GrowthBook({
  apiHost: 'https://sb.uvo.tools',
  clientKey: 'sdk-IlH2sQzjWP6lGhlG',
  enableDevMode: false,
  subscribeToChanges: true,
  attributes: {
    id: uuid,
    url: window.location.href,
  },
  trackingCallback: (experiment, result) => {
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.value,
    });

    const featureValue = getFeatureValueFromStorage(result.featureId);

    if (featureValue === undefined) {
      // Explicit set value to storage if growthbook unexpectedly returns the wrong result
      saveFeatureValueToStorage({
        featureId: result.featureId,
        variationValue: result.value,
      });
    }

    pushGtmEvent('optimize_exp_number', {
      experimentId: experiment.key,
      uuid,
      value: featureValue || result.value,
    });
  },
});

/**
 * Load features
 */
export const _initGrowthbook = async (): Promise<GB> => {
  await growthbook.loadFeatures();
  return { growthbook };
};

export const _getFeatureValue =
  (featureId, defaultDefaultValue = CONTROL_FEATURE_VALUE) =>
  async ({ growthbook }: GB) => {
    const featureValue = await growthbook.getFeatureValue(featureId, defaultDefaultValue);
    return { growthbook, featureValue: getFeatureValueFromStorage(featureId) || featureValue };
  };
